<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Egzaminy'" [name]="'Kalendarz'"></app-breadcrumb>
<div class="meetings-calendar-container">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row" fxLayoutGap="15px">
      <div class="meetings-calendar-navigate">
        <button mat-icon-button (click)="subtractMonth()"><mat-icon>chevron_left</mat-icon></button>
      </div>

      <div>
        <app-month-picker label="Miesiąc" [required]="true" [control]="monthControl"></app-month-picker>
      </div>

      <div class="meetings-calendar-navigate">
        <button mat-icon-button (click)="addMonth()"><mat-icon>chevron_right</mat-icon></button>
      </div>

<!--      <div class="meetings-calendar-checkbox">-->
<!--        <mat-checkbox color="accent" [formControl]="examsControl">Egzaminy</mat-checkbox>-->
<!--      </div>-->

<!--      <div class="meetings-calendar-checkbox">-->
<!--        <mat-checkbox color="primary" [formControl]="iddTrainingsControl">Szkolenia IDD</mat-checkbox>-->
<!--      </div>-->
<!--      <div class="meetings-calendar-checkbox">-->
<!--        <mat-checkbox color="warn"  [formControl]="newAgentTrainingControl">Szkolenie Nowy Agent</mat-checkbox>-->
<!--      </div>-->
    </div>
  </div>

  <table class="meetings-calendar-table">
    <thead>
      <tr>
        <th>Poniedziałek</th>
        <th>Wtorek</th>
        <th>Środa</th>
        <th>Czwartek</th>
        <th>Piątek</th>
        <th>Sobota</th>
        <th>Niedziela</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let i of rows | enumerate">
        <ng-container *ngIf="i === 0">
          <td *ngFor="let j of (firstWeekdayOfMonth - 1) | enumerate"></td>

          <td *ngFor="let j of (8 - firstWeekdayOfMonth) | enumerate">
            <div class="cell-container">
              <div class="day-in-month">
                {{j + 1}}
              </div>

              <div fxLayout="column" fxLayoutGap="4px">
                <app-meeting-calendar-event *ngFor="let meeting of getEvents(j + 1)" [meeting]="meeting"></app-meeting-calendar-event>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container *ngIf="i !== 0">
          <td *ngFor="let j of 7 | enumerate">

            <ng-container *ngIf="(((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1) <= daysInMonth">
              <div class="cell-container">
                <div class="day-in-month">
                  {{((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1}}
                </div>
                <div fxLayout="column" fxLayoutGap="4px">
                  <app-meeting-calendar-event *ngFor="let meeting of getEvents(((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1)" [meeting]="meeting"></app-meeting-calendar-event>
                </div>
              </div>
            </ng-container>

          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
